// src/components/TextLookup/WordChips.js

import { Box, Typography, Chip, alpha } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const WordChips = ({ 
  title, 
  words = [], 
  type = 'default',
  emptyMessage = 'None' 
}) => {
  const theme = useTheme();

  const getChipStyles = (chipType) => {
    const styles = {
      found: {
        bgcolor: alpha(theme.palette.success.main, 0.1),
        color: theme.palette.success.main,
        borderColor: alpha(theme.palette.success.main, 0.3),
      },
      notFound: {
        bgcolor: alpha(theme.palette.error.main, 0.1),
        color: theme.palette.error.main,
        borderColor: alpha(theme.palette.error.main, 0.3),
      },
      nonWord: {
        bgcolor: alpha(theme.palette.info.main, 0.1),
        color: theme.palette.info.main,
        borderColor: alpha(theme.palette.info.main, 0.3),
      },
      default: {
        bgcolor: alpha(theme.palette.primary.main, 0.1),
        color: theme.palette.primary.main,
        borderColor: alpha(theme.palette.primary.main, 0.3),
      }
    };
    return styles[chipType] || styles.default;
  };

  const formatWord = (word) => {
    return word === ' ' ? 'Space' : word;
  };

  return (
    <Box sx={{ mb: 2 }}>
      <Typography variant="body2" gutterBottom>
        <strong>{title}:</strong> {words.length}
      </Typography>
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
        {words.length > 0 ? (
          words.map((word, index) => (
            <Chip
              key={index}
              label={formatWord(word)}
              size="small"
              sx={{
                ...getChipStyles(type),
                fontWeight: 500,
                fontSize: '0.75rem'
              }}
            />
          ))
        ) : (
          <Typography variant="body2" color="text.secondary">
            {emptyMessage}
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default WordChips;